import {companyApi} from '../client';

export async function getCompaniesLatestPressReleases(
  companyId: number,
  limit: number,
  initOverride?: RequestInit,
) {
  return companyApi.getPressReleasesByCompanyId(
    {companyId, limit},
    initOverride,
  );
}

export async function getCompaniesLatestPressReleasesV2(
  companyId: number,
  limit: number,
  initOverride?: RequestInit,
) {
  return companyApi.getPressReleasesByCompanyIdV2(
    {companyId, limit},
    initOverride,
  );
}

export async function getMediaOnlyCompaniesLatestPressReleases(
  companyId: number,
  limit: number,
  initOverride?: RequestInit,
) {
  return companyApi.getMediaOnlyPressReleasesByCompanyId(
    {companyId, limit},
    initOverride,
  );
}
